import { View, Text, Pressable } from 'react-native-web';

import { GameProps, LeagueProps } from '../../../types';
import styles from './styles';

const OrganizationContactInfo = props => {
  const { game, league } = props;

  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <Text style={styles.title}>{game?._id ? 'League' : 'Program'}</Text>
        <Pressable
          onPress={() => window.open(`/l/${game?._id ? game?.league?._id : league?._id}`, '_blank')}
          style={styles.infoButton}
        >
          <Text style={styles.link}>Info page</Text>
        </Pressable>
      </View>
      <View style={styles.contactContainer}>
        <Text style={styles.contactTitle}>Host</Text>
        <View>
          <Text style={styles.contactName}>
            {league?.contact?.name || game?.league?.contact?.name}
          </Text>
          <Text>{league?.contact?.phoneNumber || game?.league?.contact?.phoneNumber}</Text>
          <Text>{league?.contact?.email || game?.league?.contact?.email}</Text>
        </View>
      </View>
    </View>
  );
};

OrganizationContactInfo.propTypes = {
  game: GameProps,
  league: LeagueProps,
};

OrganizationContactInfo.defaultProps = {
  game: {},
  league: {},
};

export default OrganizationContactInfo;
